
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"200","height":"260","viewBox":"0 0 52.917 68.792"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#f5f5f5","stroke-width":"3.817","stroke-linecap":"round","stroke-linejoin":"round","d":"M6.261 8.804h40.395v51.183H6.261z"}}),_c('path',{attrs:{"d":"M11.917 44.08v10.61h10.61l-10.61-10.61zM30.39 54.69H41V44.08L30.39 54.69zM11.917 24.711v-10.61h10.61l-10.61 10.61zM30.39 14.101H41v10.61l-10.61-10.61z","fill":"#f5f5f5"}})])
          )
        }
      }
    